import { render, staticRenderFns } from "./FormSuccessFB.vue?vue&type=template&id=105c52a6&"
import script from "./FormSuccessFB.vue?vue&type=script&lang=js&"
export * from "./FormSuccessFB.vue?vue&type=script&lang=js&"
import style0 from "./FormSuccessFB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports